/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

/**
 * PaymentConnectorLoader Input Action
 */
export class PaymentConnectorLoaderInput implements Msdyn365.IActionInput {
    constructor() {}
    public getCacheKey = () => `PaymentConnectorLoader`;
    public getCacheObjectType = () => 'PaymentConnectorLoader';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

export interface IPaymentConnectorLoaderData {
    paymentConnectorLoading: boolean; // paypal
}

const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new PaymentConnectorLoaderInput();
};

async function action(input: PaymentConnectorLoaderInput, ctx: Msdyn365.IActionContext): Promise<IPaymentConnectorLoaderData> {
    return { paymentConnectorLoading: true};
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IPaymentConnectorLoaderData>>action,
    id: 'PaymentConnectorLoader',
    input: createInput
    // isBatched: true
});
